export const DELETE_USER = 'DELETE_USER';
export const FETCH_USERS = 'FETCH_USERS';
